export default __webpack_public_path__ + "static/media/banner1.69d6c6cc.jpg";